
import { Link } from 'react-router-dom';
import BgImage from "../images/acfan.jpg";
import AboutSection from '../components/AboutSection';
import React, { useEffect, useState } from 'react';
import { URL } from '../Redux/common/url';
import Founder from '../components/Founder';
import TeamSlider from '../components/TeamSlider';
import HeroSection from '../components/HeroSection';
import VideoCards from '../components/VideoCard';

function Company() {
    const [productLists, setProductLists] = useState([]);
    const [loading, setLoading] = useState(true);
  
    useEffect(() => {
      fetchProductList();
    }, []);
  
    const fetchProductList = async () => {
      try {
        const response = await fetch(`${URL.API_BASE_URL}/publicApi/founderListPublic`);
        if (!response.ok) throw new Error("Network response was not ok");
        const data = await response.json();
        setProductLists(data?.founder || []);
        setLoading(false);
      } catch (error) {
        console.error("Fetch error:", error);
        setLoading(false);
      }
    };
  
    if (loading) return <p className="text-center py-5">Loading...</p>;
  return (
    <div className='container-fluid px-0 pt-5'>
      <div
      style={{
        backgroundImage: `url(${BgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        width: "100%",
        minHeight: "150px", // mobile friendly chhota height
        paddingTop: "30px", // desktop: 50px, mobile: 30px
        paddingBottom: "30px",
        position: "relative",
        color: "white",
      }}
      className="d-flex align-items-center"
    >
      {/* Overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.5)",
          zIndex: 1,
        }}
        className="overlay"
      ></div>

      {/* Content */}
      <div
        style={{
          position: "relative",
          zIndex: 2,
          maxWidth: "1200px",
          margin: "0 auto",
          textAlign: "center",
          padding: "0 15px",
        }}
      >
        <h1
          className="fw-bold"
          style={{ fontSize: "clamp(1.2rem, 5vw, 2rem)", fontWeight: "700" }}
        >
          Company
        </h1>
        <p
          className="lead"
          style={{
            fontSize: "clamp(0.8rem, 2.5vw, 1rem)",
            margin: "0.5rem 0 1rem 0",
          }}
        >
          SOLAR CLUB BHARAT delivers smart, eco-friendly air cooling and ventilation solutions for industries and businesses. Our mission is to create comfortable, energy-efficient spaces with reliable technology and customer-focused service.
        </p>

        {/* Breadcrumbs */}
        <nav aria-label="breadcrumb">
          <ol
            style={{
              listStyle: "none",
              display: "flex",
              justifyContent: "center",
              padding: 0,
              margin: 0,
            }}
          >
            <li style={{ marginRight: "5px" }}>
              <Link to="/" style={{ color: "white", textDecoration: "none" }}>
                Home
              </Link>
              <span style={{ margin: "0 5px" }}>/</span>
            </li>
            <li style={{ color: "white" }}>Company</li>
          </ol>
        </nav>
      </div>
    </div>

     <AboutSection />
     <Founder />
     <TeamSlider />
        <VideoCards />
                <HeroSection />
    </div>
  )
}

export default Company
